import { createContext, useContext } from 'react'

export const SidebarCollapsedContext = createContext(false)

export function useSidebarCollapsed() {
  return useContext(SidebarCollapsedContext)
}
